import { render, staticRenderFns } from "./gibseriearsiv.vue?vue&type=template&id=4dee9302"
import script from "./gibseriearsiv.vue?vue&type=script&lang=js"
export * from "./gibseriearsiv.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports